import {
  AuthenticationApi,
  Configuration,
  OperationIdRequest,
} from '@ais-ui/api-spec/oceanioprod';
import { UserCredentials } from '@ais-ui/auth';
import { readFromLocalStorage, storeInLocalStorage } from '../authHelpers';

const APIKEY = 'LVQEGHrM0P5CceeUbGWSO5gX0kZlOG877KrNlDS0';
const BASEPATH = 'https://api.oceanio.com';

export const prodConfig = {
  basePath: BASEPATH,
  headers: {
    'x-api-key': APIKEY as string,
  },
};

export const authProdEndpoint = new AuthenticationApi(
  new Configuration(prodConfig)
);

interface AccessToken {
  token: string;
  expires: Date;
}

export const getProdAccessToken = (credentials?: UserCredentials) => {
  if (!credentials) {
    return {
      expires: new Date(),
      token: 'invalid token',
    } as AccessToken;
  }

  const request = {
    loginRequest: {
      userId: credentials?.username,
      password: credentials?.password,
    },
  } as OperationIdRequest;

  const accessToken = readFromLocalStorage();

  const now = new Date();
  if (accessToken == null || new Date(accessToken.expires) < now) {
    return authProdEndpoint
      .operationId(request)
      .then((loginResponse) => {
        const newToken = {
          token: loginResponse.token ?? '',
          expires: new Date(loginResponse.expires ?? now),
        } as AccessToken;
        storeInLocalStorage({
          token: loginResponse.token ?? '',
          expires: new Date(loginResponse.expires ?? now),
        });
        return newToken;
      })
      .catch((error) => {
        return {
          expires: new Date(),
          token: 'failed',
        } as AccessToken;
      })
      .finally(() => {
        return {
          expires: new Date(),
          token: 'failed',
        } as AccessToken;
      });
  } else {
    return accessToken;
  }
};
